// extracted by mini-css-extract-plugin
export default {"badge":"user_badge__47Afs","role":"user_role__zqsbX","headerButtonContainer":"user_headerButtonContainer__+68S8"};